import { ComponentProps } from 'react';
import clsx from 'clsx';

import styles from './LoadingIndicator.module.css';

interface LoadingIndicatorProps extends ComponentProps<'div'> {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl';
  loading?: boolean;
}

export default function LoadingIndicator({
  size = 'md',
  color,
  loading = true,
  className,
  'aria-label': label = 'Loading...',
  ...props
}: LoadingIndicatorProps) {
  return (
    <div
      className={clsx(
        styles.loadingIndicator,
        styles[size],
        color && styles[color],
        !loading && styles.hidden,
        className,
      )}
      role={loading ? 'status' : undefined}
      {...props}
    >
      {loading && <span className={styles.label}>{label}</span>}
    </div>
  );
}
